import { Container } from '@pets-ui/Container/Container'
import { HStack } from '@pets-ui/HStack/HStack'
import { Link } from '@pets-ui/Link/Link'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { useProductCatalog } from '../ProductCatalogProvider/useProductCatalog'

const styles = stylex.create({
  root: {
    borderTopColor: colors.grey300,
    borderTopStyle: 'solid',
    borderTopWidth: 1,
    marginTop: 'auto',
  },
})

export const CatalogInfoLinks = () => {
  const { campaignCode } = useProductCatalog()
  const { t } = useTranslation()

  const links = [
    { href: `/campaigns/${campaignCode}/FAQ`, label: t('menu.faq') },
    { href: `/campaigns/${campaignCode}/privacy`, label: t('menu.termsOfServiceAndPrivacyPolicy') },
    { href: `/campaigns/${campaignCode}/contact`, label: t('menu.contactUs') },
  ]

  return (
    <Container py={4} rootStyle={styles.root}>
      <HStack justifyContent="center" alignItems="center" flexWrap="wrap" gap={1}>
        <Text variant="caption" color={colors.grey600}>|</Text>
        {links.map(link => (
          <HStack key={link.href} alignItems="center" gap={1}>
            <Link href={link.href}>
              <Text variant="caption" color={colors.grey600}>{link.label}</Text>
            </Link>
            <Text variant="caption" color={colors.grey600}>|</Text>
          </HStack>
        ))}
      </HStack>
    </Container>
  )
}
